/**
 * Application Configuration
 * Handles environment-specific settings for development and production
 */

const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';

// Production URL
const PRODUCTION_API_URL = 'https://games.swtorbit.com';

// Development URL (can be overridden via .env)
const DEVELOPMENT_API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * API URL for socket connections and HTTP requests
 * - Development: http://localhost:3000 (or VITE_API_URL from .env)
 * - Production: https://games.swtorbit.com
 */
export const API_URL = isDevelopment ? DEVELOPMENT_API_URL : PRODUCTION_API_URL;

/**
 * Check if running in development mode
 */
export const IS_DEVELOPMENT = isDevelopment;

/**
 * Export all config as default
 */
export default {
  API_URL,
  IS_DEVELOPMENT,
};
